module.exports = __webpack_public_path__ + "img/service03.6deb9655.png";